import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { BASE_PATH } from 'variables';
import Routes from 'Routes';
import { createStructuredSelector } from 'reselect';
import { makeSelecetAlert } from 'store/app/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { RfUiModal } from 'renfe-components';
import { setAlert } from 'store/app/actions';
import { FullScreenLoader } from 'components/FullScreenLoader/FullScreenLoader';

const selectors: any = createStructuredSelector({
  alert: makeSelecetAlert(),
} as any);

const App = () => {
  const dispatch = useDispatch();
  const { alert } = useSelector<any, any>(selectors);
  const [modal, setModal] = useState<string>('');
  const [alertText, setAlertText] = useState<string>(alert);

  const onModalClose = () => {
    setModal('');
    dispatch(
      setAlert({
        modalType: '',
        message: '',
      })
    );
  };

  useEffect(() => {
    if (alert.modalType) {
      setAlertText(alert.message);
      setModal(alert.modalType);
    }
  }, [alert]);

  return (
    <>
      <FullScreenLoader />

      <BrowserRouter basename={BASE_PATH}>
        <Routes />
      </BrowserRouter>

      <RfUiModal
        title-modal={alertText}
        id-modal="modal-alert"
        modal-type={modal}
        onModalClose={onModalClose}
      ></RfUiModal>
    </>
  );
};

export default App;
